export default {
    error_consulting_books: 'There was an error consulting books.',
    no_books_found: 'No books found.',
    search_result: 'Search result',
    title_carousel_1: 'My favorite books',
    title_carousel_2: 'The top 10 most requested books',
    title_carousel_3: 'The top 10 most valued books',
    title_carousel_4: 'Novelties',
    title_carousel_5: 'My books bought',
    title_button_card: 'Open this book',
    not_books_data: 'No books to show',
    book_tittle_required: 'The title of the book is required',
}
